export default __webpack_public_path__ + "static/media/nextjs.9dc4736a.png";